export default {"src":"/_next/static/media/deco_reward_calendar_starburst.da068231.svg","height":842,"width":842,"blurWidth":0,"blurHeight":0};